import { useEffect } from "react";
import Button from "../../components/Button";
import { BRAND, TOKEN } from "../../data/site";

export default function About() {
  useEffect(() => {
    document.title = "About - Aldebaran";
  }, []);

  return (
    <div className="page">
      <div className="page__container">
        <header className="page__hero">
          <p className="page__eyebrow">About</p>
          <h1 className="page__title">Auto-compounding rewards, built on TON</h1>
          <p className="page__lead">
            {BRAND} is a community-run staking protocol on The Open Network. Hold{" "}
            {TOKEN} in your wallet and your balance grows on its own - no
            staking screens, no lockups, no claim buttons.
          </p>
        </header>

        <section className="page__section">
          <h2>What {BRAND} is</h2>
          <p>
            {BRAND} is a decentralized autonomous organization that runs an
            elastic-supply token, {TOKEN}. Instead of asking you to stake into a
            contract and manually harvest yield, the protocol distributes
            rewards directly to every holder through a positive rebase. The token
            you already hold is the staked position.
          </p>
          <p>
            A rebase fires every 30 minutes. At each interval the protocol mints
            new {TOKEN} and spreads it proportionally across all wallets, so your
            balance increases roughly 48 times a day. Because rewards land in
            your wallet rather than a separate pool, every distribution is
            automatically restaked into your next one - the compounding is
            continuous and requires no transactions, no gas to claim, and no
            lockup period. You can move or sell at any time.
          </p>
        </section>

        <section className="page__section">
          <h2>Why holders choose it</h2>
          <div className="page__grid">
            <article className="page__card">
              <h3>Auto-Compounding</h3>
              <p>
                Rewards rebase into your wallet every 30 minutes and immediately
                earn on themselves. There is nothing to stake, claim, or
                reinvest - holding is the strategy.
              </p>
            </article>
            <article className="page__card">
              <h3>Treasury-Backed</h3>
              <p>
                A protocol-owned treasury, funded by trading fees, backs the
                {" "}{TOKEN} supply and is deployed across TON yield sources to
                sustain distributions through every market cycle.
              </p>
            </article>
            <article className="page__card">
              <h3>Community Governed</h3>
              <p>
                Reward rates, treasury allocation, and protocol parameters are
                decided by {TOKEN} holders through on-chain proposals. No team
                wallet can change the rules unilaterally.
              </p>
            </article>
            <article className="page__card">
              <h3>Built on TON</h3>
              <p>
                Running on The Open Network means sub-cent fees and near-instant
                settlement, so frequent rebases stay cheap and the contracts
                scale to a wallet-native, Telegram-first audience.
              </p>
            </article>
          </div>
        </section>

        <section className="page__section">
          <h2>The DAO and treasury</h2>
          <p>
            {BRAND} is governed by the people who hold {TOKEN}. The treasury is
            transparent and on-chain: anyone can verify its holdings, and every
            allocation that backs the rebase is the outcome of a public vote.
            Our ethos is simple - alignment over extraction. The protocol grows
            when holders grow, and governance exists to keep that incentive
            honest rather than to enrich an insider few.
          </p>
        </section>

        <div className="page__cta">
          <Button to="/instructions" className="btn--lg">
            Get started
          </Button>
          <Button to="/documents" variant="ghost" className="btn--lg">
            Read the docs
          </Button>
        </div>
      </div>
    </div>
  );
}
